module.exports = __webpack_public_path__ + "5fadf1adcf17b68544ca79d7277b2a87.pdf";